<template>
  <div class="process-field">
    <Spin fix v-show="loading"></Spin>
    <Collapse
      accordion
      @on-change="collapseChange"
      >
        <Panel
          v-for="(process, index) in processList"
          :key="process.id"
          >
          <span class="process-name">
            {{process.name}}
          </span>
          <span class="process-required">
            {{process.isRequired ? '是' : '否'}}
          </span>
          <p slot="content">
            <table class="process-field">
              <tr v-for="field in process.fieldList">
                <td>
                  字段名称：<span>{{field.name}}</span>
                </td>
                <td>
                  字段类型：<span>{{getFieldTypeName(field.type)}}</span>
                </td>
                <td>
                  是否必填：<span>{{field.isRequired ? '是' : '否'}}</span>
                </td>
                <td>
                  其他：<span>{{field.other}}</span>
                </td>
              </tr>
            </table>
          </p>
        </Panel>
    </Collapse>
  </div>
</template>

<script>
import { fieldType } from '@/assets/globalData'

export default {
  props: {
    id: {
      required: true
    }
  },
  data () {
    return {
      processList: [],
      loading: false
    }
  },
  methods: {
    collapseChange (key) {
      // 展开的时候去加载对应的进度字段
      if (key.length > 0) {
        let index = Number(key[0])
        let process = this.processList[index]
        // 没有加载过的话 请求字段信息
        if (!process.fieldList) {
          this.loading = true
          this.$http.get('/templateExamine/processField', {
            params: {
              id: process.id
            }
          }).then(res => {
            this.loading = false
            process.fieldList = res.data
          })
        }
      }
    },
    // 根据type获取自定义字段类型名称
    getFieldTypeName (type) {
      for (let t of fieldType) {
        if (t.value === type) {
          return t.name
        }
      }
    }
  },
  created () {
    this.$http.get('/templateExamine/process', {
      params: {
        id: this.id
      }
    }).then(res => {
      if (res.success) {
        this.processList = res.data
      } else {
        this.$Message.error(res.message)
      }
    })
  }
}
</script>

<style lang="less" scoped>
.process-field {
  position: relative;

  .process-name {
    margin-left: 10px;
    display: inline-block;
    width: 200px;
  }

  .process-field {
    font-size: 12px;
    color: #405060;

    tr {
      line-height: 30px;

      td {
        width: 200px;

        span {
          color: #80848F;
        }
      }
    }
    
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/templeManage/templeMarket/ProcessField.vue